import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import {
  DateTimeFormatSimple,
} from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '日期',
      dataIndex: 'createTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.createTime
          ? moment(t.createTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '通用名',
      dataIndex: 'genericName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.genericName ? t.genericName : '-'
      },
    },
    {
      title: '商品名',
      dataIndex: 'tenantMaterialsName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantMaterialsName ? t.tenantMaterialsName : '-'
      },
    },
    {
      title: '生产商',
      dataIndex: 'originName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.originName ? t.originName : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : '-'
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'periodValidity',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.periodValidity
          ? moment(t.periodValidity).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '规格',
      dataIndex: 'spec',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.spec ? t.spec : '-'
      },
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.unit ? t.unit : '-'
      },
    },
    {
      title: '数量',
      dataIndex: 'reportLossNumber',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossNumber ? t.reportLossNumber : '-'
      },
    },
    {
      title: '不合格原因',
      dataIndex: 'reportLossReason',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossReason ? t.reportLossReason : '-'
      },
    },
    {
      title: '处理意见',
      dataIndex: 'handleSuggestion',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handleSuggestion ? t.handleSuggestion : '-'
      },
    },
    {
      title: '处理时间',
      dataIndex: 'reportLossDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossDate
          ? moment(t.reportLossDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '处理结果',
      dataIndex: 'handleResult',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handleResult ? t.handleResult : '-'
      },
    },
    {
      title: '经办人',
      dataIndex: 'reportLossUserName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossUserName ? t.reportLossUserName : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '8rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('lookDetail', t)
              }}
            >
              查看
            </Button>
          </>
        )
      },
    },
  ]
}
